<template>
  <div id="root" class="h-full" v-if="data">
    <div class="flex justify-between content-center">
      <div id="sort" class="flex space-x-9" v-if="sortBar">
        <div class="cursor-pointer whitespace-nowrap" :class="{ active_sorts: isActive === 0 }" @click="synsorts">{{
          $t("综合排序") }}</div>
        <div v-for="item in sortsList" :key="item.id" @click="sort(item, item.id)"
          class="cursor-pointer whitespace-nowrap" :class="{ active_sorts: isActive === item.id }">
          {{ $t(item.title) }}
          <span class="iconfont icon-zhankai text-gray-300 active_arrows"
            :class="{ active_arrow: flag === item.id }"></span>
        </div>
      </div>
      <div class="flex justify-end space-x-8 cursor-pointer" v-if="layout">
        <div @click="largerLayout">
          <span class="iconfont icon-datu text-gray-400" :class="{ layoutActive: layoutActive }"></span>
          {{ $t("大图") }}
        </div>
        <div @click="listLayout">
          <span class="iconfont icon-liebiao text-gray-400" :class="{ layoutActive: !layoutActive }"></span>
          {{ $t("列表") }}
        </div>
      </div>
     
    </div>
    <!-- list -->
    <div class="h-full">
      <div class="flex flex-wrap h-full mx-[-0.35rem]">
        <div id="item" class="px-[0.35rem] py-[0.35rem]" :style="{ width: _span }" v-for="(item, k) in data.items"
          :key="k">
          <slot :item="item"></slot>
        </div>
      </div>
    </div>

    <!-- 分页 -->
    <div class="mt-13" v-if="pagerBar">
      <el-pagination background layout="prev, pager, next" :total="data.total" :page-size="36"
        @current-change="handleCurrentChange" :current-page.sync="currentPage"
        :hide-on-single-page="true"></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  onMounted,
  reactive,
  ref,
  toRefs,
  computed,
  watchEffect,
  watch,
} from "@vue/composition-api";
import { getAreas } from "/src/API/flight/getAreas.js";
import flightItem from "@/components/flight/flightItem.vue";
import { find } from "ramda";

export default {
  components: { flightItem },
  props: {
    flightBar: Boolean,
    sortBar: Boolean,
    pagerBar: Boolean,
    span: Number,
    data: Object,
    layout: Boolean,
  },

  setup(props, ctx) {
    const areas = reactive({});
    const thatVuex = ctx.root.$store.state.receiving;
    const form = reactive({
      area: thatVuex.localId,
      q__date: thatVuex.localTime,
      size: 10000,
      page: 1,
    });
    const showItem = ref();
    const flightItem = ref();
    const flightItemLength = computed(() =>
      flightItem?.value?.length ? flightItem.value.length : 0
    );
    const flightList = async () => {
      flightItem.value = (
        await ctx.root.$callapi("getFlightList", form)
      ).data.items;
      const defaultFlight_id = (await ctx.root.$callapi("getDefaultFlight"))
        .data.id;
      showItem.value = find(({ id }) => id === defaultFlight_id)(
        flightItem.value
      );
    };
    onMounted(() => {
      if (props.flightBar) {
        // flightList();
      }
    });
    const toPercent = (val) => (1 / val) * 100 + "%";
    const _span = ref(toPercent(props.span));
    watchEffect(() => {
      _span.value = toPercent(props.span);
    });
    watch(
      [
        () => ctx.root.$route.query.color,
        () => ctx.root.$route.query.classify_id,
        // () => ctx.root.$route.query.page,
      ],
      () => {
        isActive.value = Number(0);
        flag.value = Number(0);
        currentPage.value = ctx.root.$route.query?.page;
      }
    );
    const sortsList = reactive([
      // { orderby: "-updated", title: "综合排序" },
      { id: 1, orderby: "-sales", title: "销量" },
      { id: 2, orderby: "-price", title: "价格" },
      { id: 3, orderby: "-id", title: "最新" },
    ]);

    const currentPage = ref(1);
    const currentSorts = ref("-updated");
    const handleCurrentChange = (val) => {
      ctx.root.$router
        .push({
          name: "Product",
          query: {
            ...ctx.root.$route.query,
            page: currentPage.value,
            orderby: currentSorts.value,
          },
        })
        .catch(() => { });
    };
    const changeId = async (id) => {
      ctx.root.$store.commit("SET_localId", id);
      ctx.emit("changeArea", id);
      flightList();
    };

    const changeMore = async (item) => {
      await ctx.root.$callapi("setNationalSetting", { flight: item.id });
      showItem.value = item;
      ctx.emit("reload");
    };
    const changeDate = async (date) => {
      ctx.root.$store.commit("SET_localTime", date);
      flightList();
    };
    const isActive = ref(Number(0));
    const flag = ref(Number(0));
    const sort = (...args) => {
      delete ctx.root.$route.query.page;
      currentPage.value = 1;
      isActive.value = args[1];
      if (flag.value === args[1]) {
        ctx.emit("sorts", args[0].orderby.slice(1));
        flag.value = null;
        currentSorts.value = args[0].orderby.slice(1);
      } else {
        ctx.emit("sorts", args[0].orderby);
        flag.value = args[1];
        currentSorts.value = args[0].orderby;
      }
    };
    //综合排序
    const synsorts = () => {
      currentPage.value = 1;
      isActive.value = Number(0);
      flag.value = Number(0);
      ctx.emit("synsorts");
      currentSorts.value = "-updated";
    };
    const layoutActive = ref(true);
    const largerLayout = () => {
      ctx.emit("changeSpan", 5);
      layoutActive.value = true;
    };
    const listLayout = () => {
      ctx.emit("changeSpan", 1);
      layoutActive.value = false;
    };
    return {
      _span,
      handleCurrentChange,
      currentPage,
      sortsList,
      ...toRefs(areas),
      changeId,
      form,
      flightItem,
      flightItemLength,
      showItem,
      changeMore,
      changeDate,
      isActive,
      sort,
      flag,
      synsorts,
      largerLayout,
      listLayout,
      layoutActive,
    };
  },
};
</script>

<style scoped lang="scss">#sort, #flight {
  margin-bottom: 1rem;
}
.select ::v-deep .el-input__prefix {
  top: 3px;
}
.active {
  display: block;
}
.select_icon {
  transform: rotate(-180deg);
  transition: all 0.5s;
}
.select_ul {
  --tw-border-opacity: 1;
  border-color: rgba(16, 185, 129, var(--tw-border-opacity));
}
.date ::v-deep .el-date-editor.el-input {
  width: 10rem;
}
.active_sorts {
  --tw-text-opacity: 1;
  color: rgba(21, 186, 99, var(--tw-text-opacity));
}
.active_arrows {
  display: inline-block;
  transition: all 0.5s;
}
.active_arrow {
  transform: rotate(180deg);
}
.layoutActive {
  --tw-text-opacity: 1;
  color: rgba(23, 201, 106, var(--tw-text-opacity));
}</style>
